<template>
  <div id="jsoneditor" ref="jsoneditor" style="height: 500px;"></div>
</template>

<script>
import JSONEditor from 'jsoneditor';
import 'jsoneditor/dist/jsoneditor.css';  // <-- Add this line
import 'ace-builds/src-noconflict/theme-monokai'

export default {

  props: ['invalid', 'modelValue'],

  data() {
    return {
      editor: null,
      isUpdating: false,
    }
  },

  watch: {
    modelValue: {
      handler(newVal) {
        if (this.editor && !this.isUpdating) {
          this.editor.update(newVal);
          console.log('Editor updated with new modelValue');
        }
      },
    }
  },

  mounted() {
    const container = this.$refs.jsoneditor;

    // const schema = {
    //   "$schema": "http://json-schema.org/draft-07/schema#",
    //   "type": "array",
    //   "items": {
    //     "type": "object",
    //     "properties": {
    //       "name": {
    //         "type": "string",
    //         "description": "The name of the tab"
    //       },
    //       "properties": {
    //         "type": "array",
    //         "description": "List of property names",
    //         "items": {
    //           "type": "string"
    //         },
    //         "minItems": 1
    //       }
    //     },
    //     "required": ["name", "properties"],
    //     "additionalProperties": false
    //   }
    // };

    const options = {
      mode: 'code',
      theme: "ace/theme/monokai",
      allowSchemaSuggestions: true,
      // schema: schema,
      menubar: true,
      onChange: () => {
        try {
          this.isUpdating = true
          const updated = this.editor.get()
          this.$emit('update:modelValue', updated)
          this.$emit('updateError', null)
        } catch (e) {
          this.$emit('updateError', e.message)
          // ignore parse errors until valid JSON is entered
        } finally {
          this.isUpdating = false
        }
      }
    };
    this.editor = new JSONEditor(container, options);
    const initialJson = { "example": "data" };
    this.editor.set(this.modelValue || initialJson);
  }
}
</script>